import { proxy, arrayProxy, fnProxy, fnArrayProxy } from "snek-query";
var OAuthProvider;
(function (OAuthProvider) {
    OAuthProvider["google"] = "google";
    OAuthProvider["azure"] = "azure";
})(OAuthProvider || (OAuthProvider = {}));
var OAuthProviderInputInput;
(function (OAuthProviderInputInput) {
    OAuthProviderInputInput["google"] = "google";
    OAuthProviderInputInput["azure"] = "azure";
})(OAuthProviderInputInput || (OAuthProviderInputInput = {}));
var EmailAddressTypeInputInput;
(function (EmailAddressTypeInputInput) {
    EmailAddressTypeInputInput["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
    EmailAddressTypeInputInput["EMAIL_ID"] = "EMAIL_ID";
    EmailAddressTypeInputInput["USER_ID"] = "USER_ID";
})(EmailAddressTypeInputInput || (EmailAddressTypeInputInput = {}));
export class Query {
    constructor() { this.__typename = ""; this.user = fnProxy(User); this.allUser = fnArrayProxy(User); this.userMe = proxy(User); this.resource = fnProxy(Resource); this.shopifyAllProductId = () => []; this.version = ""; }
}
export class User {
    constructor() { this.__typename = ""; this.id = ""; this.username = ""; this.primaryEmailAddress = ""; this.isAdmin = false; this.isActive = false; this.createdAt = ""; this.details = proxy(Details); this.resource = proxy(Resource); this.emails = arrayProxy(UserEmail); }
}
export class Details {
    constructor() { this.__typename = ""; this.firstName = null; this.lastName = null; }
}
export class Resource {
    constructor() { this.__typename = ""; this.id = ""; this.name = ""; this.config = null; this.secret = fnProxy(Secret); }
}
export class Secret {
    constructor() { this.__typename = ""; this.name = ""; this.value = null; }
}
export class UserEmail {
    constructor() { this.__typename = ""; this.id = ""; this.emailAddress = ""; this.isPrimary = false; this.config = proxy(EmailConfig); }
}
export class EmailConfig {
    constructor() { this.__typename = ""; this.id = ""; this.isEnabled = false; this.externalCredential = proxy(ExternalCredential); }
}
export class ExternalCredential {
    constructor() { this.__typename = ""; this.smtp = proxy(SMTPCredential); this.oauth = proxy(OAuthCredential); }
}
export class SMTPCredential {
    constructor() { this.__typename = ""; this.host = ""; this.port = null; this.username = ""; this.password = ""; this.secure = false; }
}
export class OAuthCredential {
    constructor() { this.__typename = ""; this.provider = null; this.accessToken = ""; this.refreshToken = ""; }
}
export class Mutation {
    constructor() { this.__typename = ""; this.userSignIn = fnProxy(UserSignIn); this.userSignOut = () => null; this.userRefresh = fnProxy(UserRefresh); this.userSSO = fnProxy(UserSSO); this.userRegister = fnProxy(UserRegister); this.userUpdate = fnProxy(User); this.userDelete = () => false; this.userEmailCreate = fnProxy(UserEmail); this.userEmailUpdate = fnProxy(UserEmail); this.userEmailDelete = () => false; this.userExternalCredentialCreate = () => ""; this.jaenPublish = () => ""; this.shopifyProductCreate = () => ""; this.shopifyProductUpdate = () => ""; this.shopifyProductDelete = () => ""; this.mailpressMailSchedule = () => ""; }
}
export class UserSignIn {
    constructor() { this.__typename = ""; this.tokenPair = proxy(TokenPair); this.user = proxy(User); this.me = proxy(User); }
}
export class TokenPair {
    constructor() { this.__typename = ""; this.accessToken = ""; this.refreshToken = ""; }
}
export class UserRefresh {
    constructor() { this.__typename = ""; this.tokenPair = proxy(TokenPair); this.me = proxy(User); }
}
export class UserSSO {
    constructor() { this.__typename = ""; this.tokenPair = proxy(TokenPair); this.user = proxy(User); this.me = proxy(User); }
}
export class UserRegister {
    constructor() { this.__typename = ""; this.user = proxy(User); this.accessToken = ""; }
}
